import { render, staticRenderFns } from "./BlogPostCardTemplate.vue?vue&type=template&id=8661b34c&scoped=true&"
import script from "./BlogPostCardTemplate.vue?vue&type=script&lang=js&"
export * from "./BlogPostCardTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostCardTemplate.vue?vue&type=style&index=0&id=8661b34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8661b34c",
  null
  
)

export default component.exports